import { MicrositeButtonShadow } from '@web/enums/MicrositeButtonShadow';

export default function (buttonShadow: MicrositeButtonShadow): string {
  const buttonBoxShadow = {
    [MicrositeButtonShadow.NONE]: '',
    [MicrositeButtonShadow.LIGHT]:
      '0 1px 3px rgb(0 0 0 / 0.12), 0 4px 8px -2px rgb(0 0 0 / 0.15)',
    [MicrositeButtonShadow.MEDIUM]:
      '0 4px 10px -4px rgb(0 0 0 / 0.35), 0 2px 4px -1px rgb(0 0 0 / 0.2)',
    [MicrositeButtonShadow.HEAVY]: '6px 6px 0 0 rgb(35 31 32 / 1)',
  }[buttonShadow];

  if (buttonBoxShadow === undefined) {
    throw new Error(`Unknown button shadow: ${buttonBoxShadow}`);
  }

  return buttonBoxShadow;
}
